// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"style_Arrow__wycSH","Arrow_right":"style_Arrow_right__1Q-q8","Arrow_disabled":"style_Arrow_disabled__3WF_8"};